import React from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import { dateToView, numberToMoney } from '../../../utils/util';
import { TYPE_DATE } from '../../../utils/util';
import { TYPE_MONEY } from '../../../utils/util';
import { TYPE_TIMESTAMP } from '../../../utils/util';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(1),
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexWrap: 'wrap',
    },
    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  header: {
    maxWidth: '100%',
    width: 240,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
      flexBasis: '100%',
    },
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  stats: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
    },
  },
  actions: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
    },
  },
}));

const renderCampo = (dado, coluna) => {
  if (coluna.type === TYPE_DATE) {
    return dateToView(dado[coluna.dataColumn], coluna.time || false);
  } else if (coluna.type === TYPE_MONEY) {
    return numberToMoney(dado[coluna.dataColumn]);
  } else if (coluna.type === TYPE_TIMESTAMP) {
    return dateToView(dado[coluna.dataColumn], true);
  } else return dado[coluna.dataColumn];
};

const renderColunas = (classes, colunas, dado) => {
  return colunas.map((coluna, i) => {
    return (
      <div className={classes.stats} key={`col-${i}`}>
        <Typography variant="h6">{renderCampo(dado, coluna)}</Typography>
        <Typography variant="body2">{coluna.name}</Typography>
      </div>
    );
  });
};

const ProjectCard = props => {
  const { project, className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      key={`cd-${project[props.colunas[0].dataColumn]}`}>
      <CardContent className={classes.content} key={`cdc-${project[props.colunas[0].dataColumn]}`}>
        {renderColunas(classes, props.colunas, project)}
      </CardContent>
    </Card>
  );
};

ProjectCard.propTypes = {
  className: PropTypes.string,
  project: PropTypes.object.isRequired,
  colunas: PropTypes.array.isRequired,
};

export default ProjectCard;
